import React from 'react';
import Modal from '../../../components/Modal/Modal';
import Button from '../../../components/Button/Button';
import './MaxItemsModal.css';

function MaxItemsModal({limit, toCart, onClose}) {
    const handleToCart = () => {
        if (toCart) toCart();
    };

    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <Modal title='Adventencia' showCloseButton={false} onClose={handleClose}>
            <div className='max-items-modal'>
                <div className='max-items-modal_description'>Sólo se pueden tener un máximo de {limit} productos diferentes en el carro de compras. Por favor elimine algunos productos de carro antes de agregar uno nuevo.</div>
                <div className='max-items-modal_buttons'>
                    <div className='max-items-modal_button'>
                        <Button
                            icon={undefined}
                            label='Ir al carro de compras'
                            labelColor='#FFFFFF'
                            backgroundColor='#002EFF'
                            borderColor='#002EFF'
                            borderWidth={0}
                            borderRadius={50}
                            padding='15px 10px'
                            paddingTarget='label'
                            margin={0}
                            width='100%'
                            minWidth={undefined}
                            maxWidth={undefined}
                            height='auto'
                            minHeight={undefined}
                            maxHeight={undefined}
                            transition='label'
                            fontSize={14}
                            boxShadow='unset'
                            isLoading={false}
                            loadLabel={undefined}
                            disabled={false}
                            showPulseEffect={false}
                            notificationNumber={undefined}
                            notificationBackgroundColor={undefined}
                            notificationLabelColor={undefined}
                            onClick={handleToCart}
                        />
                    </div>
                    <div className='max-items-modal_button'>
                        <Button
                            icon={undefined}
                            label='Cerrar'
                            labelColor='#002EFF'
                            backgroundColor='#FFFFFF'
                            borderColor='#002EFF'
                            borderWidth={0}
                            borderRadius={50}
                            padding='15px 10px'
                            paddingTarget='label'
                            margin={0}
                            width='100%'
                            minWidth={undefined}
                            maxWidth={undefined}
                            height='auto'
                            minHeight={undefined}
                            maxHeight={undefined}
                            transition='label'
                            fontSize={14}
                            boxShadow='unset'
                            isLoading={false}
                            loadLabel={undefined}
                            disabled={false}
                            showPulseEffect={false}
                            notificationNumber={undefined}
                            notificationBackgroundColor={undefined}
                            notificationLabelColor={undefined}
                            onClick={handleClose}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default MaxItemsModal;